'use client'

import {useCookieConsentStore} from '@local/stores/stores'
import {Button, Locale} from '@local/ui/components'

export const CookiePreferenceButton = () => {
	const setIsPanelOpened = useCookieConsentStore(state => state.setIsPanelOpened)

	const handleCookiePreference = () => {
		setIsPanelOpened(true)
	}

	return (
		<Button variant='underlined' className='tracking-widest text-9' onClick={handleCookiePreference}>
			<Locale>Cookie preferences</Locale>
		</Button>
	)
}
